export default __webpack_public_path__ + "static/media/logo.1444ffb4.svg";